module.exports = __webpack_public_path__ + "static/media/img-header-takeprize.d5e27b48.png";